import React, { useState, useRef, useEffect, useContext, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BiSolidCricketBall, BiFootball, BiTennisBall } from "react-icons/bi";
import "./UpcomingEvents.css";
// import "../../../src/App.css";
import { TimeContext } from "../TimeContext/TimeContext";
import { useSelector, useDispatch } from "react-redux";
import { getAllEvents } from "../../redux/slice/event/eventSlice";
import { emptyUserInfo } from "../../redux/slice/userInfo/userInfoSlice";
import Helper from "../../helper";
import ScrollGames from "../ScrollGames/ScrollGames";
import TableRow from "../TableRow/index";
import { useMediaQuery } from "react-responsive";

const DASHBOARD_SPORT_ORDER = [4, 1, 2];

const UpcomingEvents = ({
  eventType,
  showDashboardInplay = false,
  tableTitle = "INPLAY",
}) => {
  const [currentTime, setCurrentTime] = useState(new Date("2024-08-26T04:30"));
  const scrollRefs = useRef([]); // Array of refs for each event box
  const { setMatchTime } = useContext(TimeContext);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const userInfo = Helper();

  const userInfos = useSelector((state) => state.events); // Use selector to access state
  const [allEvents, setAllEvents] = useState([]);
  const [isEventLoading, setIsEventLoading] = useState(true);
  const [events, setEvents] = useState([]);

  const [mobileInplayFilter, setMobileInplayFilter] = useState(null);
  const [mobileFilterMotion, setMobileFilterMotion] = useState(null);
  const isMobile = useMediaQuery({ maxWidth: 991 });

  const sportFromUrl = Number(
    new URLSearchParams(location.search).get("sport"),
  );

  const selectedSportFromUrl = [4, 1, 2].includes(sportFromUrl)
    ? sportFromUrl
    : null;

  const effectiveEventType =
    selectedSportFromUrl ??
    (eventType === undefined || eventType === null ? 4 : eventType);

  const mobileSectionTitle =
    {
      1: "FOOTBALL",
      2: "TENNIS",
      4: "CRICKET",
    }[Number(effectiveEventType)] || "IN PLAY";

  const isDashboardInplayView =
    selectedSportFromUrl === null && showDashboardInplay;

  const effectiveTableTitle =
    selectedSportFromUrl !== null ? "EXCHANGE" : tableTitle;

  const sportConfig = {
    4: {
      label: "CRICKET",
      icon: "/Images/4-1.png",
    },
    1: {
      label: "FOOTBALL",
      icon: "/Images/1-1.png",
    },
    2: {
      label: "TENNIS",
      icon: "/Images/2-1.png",
    },
  };

  // const dashboardSportOrder = [4, 1, 2];

  const isInplayEvent = (event) =>
    String(event?.is_inplay).toLowerCase() === "true";

  const dashboardInplayGroups = useMemo(() => {
    if (!isDashboardInplayView) return [];

    return DASHBOARD_SPORT_ORDER.map((sportType) => ({
      sportType,
      sport: sportConfig[sportType],
      events: allEvents.filter(
        (event) =>
          Number(event?.event_type) === sportType && isInplayEvent(event),
      ),
    }));
  }, [allEvents, isDashboardInplayView]);

  const activeSport = sportConfig[effectiveEventType] || sportConfig[4];

  // console.log("SPORT CHECK", {
  //   search: location.search,
  //   sportFromUrl,
  //   selectedSportFromUrl,
  //   effectiveEventType,
  //   activeSport,
  // });

  // const ActiveSportIcon = activeSport.Icon;

  // const [eventType, setEventType] = useState(4)

  // console.log('userInfos',userInfos);

  useEffect(() => {
    dispatch(
      getAllEvents({
        user_id: userInfo ? userInfo._id : "",
      }),
    );
  }, []);

  // useEffect(() => {
  //   if (userInfos.events.length) {
  //     const newEvents = userInfos?.events[0]?.competitions[0]?.events || [];
  //     setIsEventLoading(false);
  //     if (newEvents.length > 0 && (allEvents.length == 0 || JSON.stringify(newEvents) !== JSON.stringify(allEvents))) {
  //       setAllEvents(newEvents);
  //     }
  //   }
  // }, [userInfos.events.length])

  useEffect(() => {
    if (
      userInfos &&
      Array.isArray(userInfos.events) &&
      userInfos.events.length > 0
    ) {
      // Flatten all competitions' events into one array
      const allNewEvents = userInfos.events
        .flatMap((ev) => ev.competitions || [])
        .flatMap((comp) => comp.events || []);
      setIsEventLoading(false);
      if (
        allNewEvents.length > 0 &&
        (allEvents.length === 0 ||
          JSON.stringify(allNewEvents) !== JSON.stringify(allEvents))
      ) {
        console.log("Asll Events : ", allNewEvents);
        setAllEvents(allNewEvents);
      }
    }
  }, [
    userInfos && Array.isArray(userInfos.events) ? userInfos.events.length : 0,
    allEvents.length,
  ]);

  const initializeScrollRefs = (index) => {
    if (!scrollRefs.current[index]) {
      scrollRefs.current[index] = React.createRef(); // Initialize the ref for the event box
    }
  };

  const handleScroll = (scrollingRef) => {
    if (scrollingRef?.current) {
      const scrollLeftValue = scrollingRef.current.scrollLeft; // Get the scroll position of the scrolled box
      scrollRefs.current.forEach((ref) => {
        if (ref.current && ref !== scrollingRef) {
          ref.current.scrollLeft = scrollLeftValue; // Update the scroll position for all other boxes
        }
      });
    }
  };

  // const filteredEvents = useMemo(() => {
  //   if (allEvents.length > 0) {
  //     return allEvents.filter(event => event.event_type == eventType);
  //   }
  //   return [];
  // }, [allEvents, eventType]);

  const filteredEvents = useMemo(() => {
    if (!allEvents.length) return [];

    if (isDashboardInplayView) {
      return DASHBOARD_SPORT_ORDER.flatMap((sportType) =>
        allEvents.filter(
          (event) =>
            Number(event?.event_type) === sportType && isInplayEvent(event),
        ),
      );
    }

    return allEvents.filter((event) =>
      effectiveEventType === "In-Play"
        ? isInplayEvent(event)
        : Number(event?.event_type) === Number(effectiveEventType),
    );
  }, [
    allEvents,
    effectiveEventType,
    isDashboardInplayView,
    // dashboardSportOrder,
  ]);

  useEffect(() => {
    setEvents(filteredEvents);
  }, [filteredEvents]);

  // useEffect(() => {
  //   if (!socketStatus || events.length === 0) {
  //     return;
  //   }

  //   events.forEach((event) => {
  //     sendMessage({
  //       action: "JOIN",
  //       data: {
  //         username: userInfo?._id || "guest",
  //         event_id: String(event.event_id),
  //       },
  //     });
  //   });
  // }, [socketStatus, events, sendMessage, userInfo?._id]);

  const handleMatchClick = (time) => {
    setMatchTime(time);
    navigate("/matchupdates"); // Navigate to MatchUpdates
  };

  useEffect(() => {
    scrollRefs.current.forEach((ref) => {
      if (ref.current) {
        // Add scroll event listener to each event box
        ref.current.addEventListener("scroll", () => handleScroll(ref));
      }
    });

    // Clean up event listeners when component unmounts
    return () => {
      scrollRefs.current.forEach((ref) => {
        if (ref.current) {
          ref.current.removeEventListener("scroll", () => handleScroll(ref));
        }
      });
    };
  }, []);

  const renderDesktopSportHeader = (sport) => (
    <div className="reference-exchange-header">
      <div className="reference-exchange-sport-area">
        <div className="reference-exchange-sport-name">
          <img
            src={`${process.env.PUBLIC_URL}${sport.icon}`}
            alt=""
            className="reference-exchange-sport-icon"
            aria-hidden="true"
          />
          <span>{sport.label}</span>
        </div>

        <div className="reference-exchange-filters">
          <button type="button">✚ LIVE</button>
          <button type="button">✚ VIRTUAL</button>
          <button type="button">✚ PREMIUM</button>
        </div>
      </div>

      <div className="reference-exchange-outcomes">
        <span>1</span>
        <span>X</span>
        <span>2</span>
      </div>
    </div>
  );

  // if (isEventLoading || true) {

  if (isEventLoading) {
    return (
      <div
        className="reference-events-loader"
        role="status"
        aria-label="Loading events"
      >
        <div className="reference-events-loader-spinner" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="main">
        {/* <div className="w-full flex items-center justify-between border-b border-border_color_primary rounded-t-[10px] py-1.5 px-[7px] bg-bg_inPlayBlockBg">
          <div className="flex items-center text-text_color_primary2 font-semibold text-[18px] tracking-wide justify-start w-full gap-[5px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="29"
              height="29"
              viewBox="0 0 29 29"
              fill="none"
            >
              <g clipPath="url(#clip0_1696_2272)">
                <path
                  d="M14.5 2.83337C8.06004 2.83337 2.83337 8.06004 2.83337 14.5C2.83337 20.94 8.06004 26.1667 14.5 26.1667C20.94 26.1667 
                        26.1667 20.94 26.1667 14.5C26.1667 8.06004 20.94 2.83337 14.5 2.83337ZM12.1667 19.75V9.25004L19.1667 14.5L12.1667 19.75Z"
                  fill="var(--icon-color-secondary)"
                ></path>
              </g>
              <defs>
                <clipPath id="clip0_1696_2272">
                  <rect
                    width="28"
                    height="28"
                    fill="white"
                    transform="translate(0.5 0.5)"
                  ></rect>
                </clipPath>
              </defs>
            </svg>
            <span>In Play</span>
          </div>
          <div className="w-max text-nowrap" title="Open Bets Count">
            <span className="text-xs tracking-wide text-text_color_primary2 text-nowrap whitespace-nowrap font-normal">Open Bets</span>
            <sup className="font-features sups">
              <span className="text-x font-normal tracking-wide text-text_color_primary2 bg-bg_brand_primary min-w-4 min-h-4 text-center px-1 py-0.5 font-lato rounded-full">0</span>
            </sup>
          </div>
        </div> */}
        {events?.length > 0 && isMobile && (
          <div className="reference-mobile-inplay-header">
            <div className="reference-mobile-inplay-title">
              <i
                className="fa fa-play-circle inplay-popular-header__logo-icon"
                aria-hidden="true"
              />
              <span>{mobileSectionTitle}</span>
            </div>

            <div className="reference-mobile-inplay-filters">
              {[
                { id: "live", label: "LIVE" },
                { id: "virtual", label: "VIRTUAL" },
                { id: "premium", label: "PREMIUM" },
              ].map((filter) => (
                <button
                  key={filter.id}
                  type="button"
                  className={
                    mobileInplayFilter === filter.id
                      ? "reference-mobile-inplay-filter-active"
                      : ""
                  }
                  onClick={() => {
                    const isSelected = mobileInplayFilter === filter.id;

                    setMobileFilterMotion({
                      id: filter.id,
                      type: isSelected ? "remove" : "add",
                    });

                    setMobileInplayFilter(isSelected ? null : filter.id);
                  }}
                >
                  <span
                    key={`${filter.id}-${mobileInplayFilter === filter.id ? "active" : "idle"}`}
                    className={[
                      "reference-mobile-inplay-filter-icon",
                      mobileFilterMotion?.id === filter.id
                        ? `reference-mobile-inplay-filter-icon-${mobileFilterMotion.type}`
                        : "",
                    ]
                      .filter(Boolean)
                      .join(" ")}
                  >
                    {mobileInplayFilter === filter.id ? "✓" : "✚"}
                  </span>
                  {filter.label}
                </button>
              ))}
            </div>
          </div>
        )}

        {events?.length > 0 && !isMobile && (
          <div className="bg-bg_color_primary grid grid-cols-12 items-center min-h-[32px] rounded-t-none d-none">
            {/* Left: Icon + Label */}
            <div className="col-span-6 lg:col-span-6 flex items-center gap-x-2 px-2 py-2.5 h-full">
              {effectiveEventType === 4 && (
                <>
                  {/* Cricket SVG */}
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 19 18"
                    fill="var(--icon-color-ternary)"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.36255 16.7108C4.35063 16.7037 4.34109 16.6966 4.32917 16.6895C3.88333 16.4077 3.4518 16.107 3.05842 15.7566C2.91299 15.6263 2.77709 15.489 2.63404 15.3564C2.59828 15.3256 2.61974 15.3067 2.63642 15.283C2.81524 15.0533 2.99643 14.8213 3.17524 14.5916C3.92148 13.635 4.6701 12.676 5.41634 11.7194C6.27225 10.6231 7.12578 9.52678 7.98169 8.43047C8.8066 7.37204 9.6339 6.31125 10.4588 5.25282C11.329 4.14231 12.1969 3.02942 13.0647 1.9189C13.2292 1.70816 13.3961 1.49506 13.5582 1.28195C13.5797 1.25354 13.5916 1.24644 13.6274 1.26538C13.9468 1.45244 14.2472 1.67028 14.5333 1.90233C14.6692 2.01125 14.8123 2.1107 14.9458 2.22199C15.0817 2.34038 15.2128 2.46351 15.3439 2.58663C15.3773 2.61742 15.3535 2.63162 15.3368 2.65293C15.1008 2.95602 14.8623 3.26147 14.6263 3.56455C13.9254 4.46433 13.222 5.36411 12.5211 6.26389C11.7343 7.27259 10.9476 8.28129 10.1584 9.29C9.42648 10.2277 8.69693 11.1653 7.965 12.103C7.12101 13.1827 6.2794 14.2648 5.43542 15.3446C5.08971 15.7874 4.7464 16.2278 4.40069 16.6706C4.39116 16.6848 4.38401 16.7037 4.36255 16.7108Z"
                      fill="#8B191B"
                    ></path>
                    <path
                      d="M17.9928 8.49706C17.9761 8.16556 17.9451 7.83643 17.8927 7.50967C17.8283 7.11424 17.7305 6.72591 17.6137 6.33995C17.3777 5.55146 17.0225 4.8198 16.5814 4.12365C16.4336 3.89161 16.2762 3.66903 16.1022 3.45119C16.0879 3.46776 16.0736 3.48197 16.0617 3.49854C15.7231 3.93423 15.3869 4.36991 15.0484 4.80322C14.2426 5.84271 13.4367 6.88219 12.6309 7.92167C11.7988 8.99431 10.9691 10.0669 10.1371 11.1372C9.34792 12.1554 8.55639 13.1759 7.76724 14.1941C6.99001 15.1981 6.2104 16.202 5.43317 17.2036C5.40456 17.2391 5.40695 17.251 5.44986 17.2699C6.43213 17.6867 7.45492 17.9211 8.52063 17.9803C9.05468 18.0087 9.58872 17.9921 10.1204 17.9258C10.571 17.869 11.0144 17.7814 11.4483 17.6511C12.247 17.412 13.0052 17.0852 13.7157 16.6495C14.4619 16.1925 15.1247 15.6385 15.7112 14.9897C16.0998 14.5587 16.4455 14.097 16.7411 13.5998C17.1917 12.8421 17.5136 12.0346 17.7353 11.1846C17.8736 10.6518 17.9594 10.1096 17.988 9.56022C18.0095 9.20741 18.0119 8.85224 17.9928 8.49706ZM9.17865 15.8587C8.93547 16.1618 8.70182 16.472 8.46579 16.7821C8.3299 16.9621 8.15586 17.0473 7.92936 16.9952C7.69572 16.9408 7.54552 16.7443 7.5479 16.5051C7.54552 16.382 7.58843 16.2754 7.66472 16.1783C7.90075 15.8776 8.13678 15.5745 8.37281 15.2738C8.52778 15.0797 8.7805 15.0063 8.98792 15.1128C9.31931 15.2809 9.336 15.6598 9.17865 15.8587ZM11.105 13.2612C11.0955 13.3606 11.055 13.4435 10.9954 13.5216C10.7569 13.8271 10.5233 14.1349 10.2873 14.4403C10.1633 14.6014 10.0012 14.6795 9.79853 14.644C9.58157 14.6061 9.44567 14.4688 9.39322 14.2557C9.38369 14.2201 9.38369 14.1823 9.3813 14.1444C9.3813 14.026 9.42183 13.9194 9.49336 13.8271C9.73654 13.5169 9.97972 13.2043 10.2253 12.8941C10.3588 12.726 10.6115 12.6621 10.807 12.7426C10.9977 12.8231 11.1265 13.0457 11.105 13.2612ZM12.8407 11.1443C12.5927 11.4569 12.3519 11.7742 12.0992 12.082C11.98 12.2264 11.8131 12.3069 11.6176 12.2643C11.4078 12.2169 11.2695 12.082 11.2242 11.8689C11.1932 11.7268 11.2266 11.5918 11.3172 11.4734C11.5485 11.1704 11.7845 10.872 12.0134 10.5666C12.2494 10.2493 12.7501 10.28 12.9098 10.666C12.936 10.7276 12.9432 10.7915 12.9432 10.8554C12.9432 10.9644 12.9098 11.0591 12.8407 11.1443ZM14.6645 8.77646C14.419 9.09139 14.1758 9.41105 13.9326 9.72834C13.7991 9.90119 13.5678 9.97459 13.358 9.90829C13.1602 9.84673 13.0195 9.66204 13.0123 9.44656C13.0076 9.31633 13.0576 9.19794 13.1363 9.09849C13.3747 8.79067 13.6203 8.48996 13.8635 8.18687C14.0018 8.01639 14.2235 7.95009 14.4238 8.02112C14.624 8.09216 14.7575 8.27922 14.7599 8.49943C14.7528 8.59414 14.7313 8.69122 14.6645 8.77646ZM16.5099 6.40152C16.2667 6.71644 16.0235 7.03373 15.7827 7.34866C15.6254 7.55466 15.4084 7.62333 15.1795 7.53808C14.9888 7.46705 14.86 7.27288 14.8648 7.03847C14.8624 6.94375 14.9077 6.8372 14.9816 6.74012C15.2153 6.44177 15.4465 6.14342 15.6826 5.84508C15.8638 5.61303 16.1308 5.56804 16.3835 5.72432C16.5933 5.85691 16.6601 6.20736 16.5099 6.40152Z"
                      fill="#8B191B"
                    ></path>
                    <path
                      d="M12.5188 0.709924C11.5127 0.274241 10.4589 0.0469281 9.36222 0.00667475C8.58975 -0.0217394 7.82444 0.0398245 7.06866 0.205573C6.33911 0.364219 5.63817 0.605739 4.97299 0.94434C3.79522 1.54104 2.7915 2.35084 1.96896 3.38559C1.49213 3.98702 1.09398 4.63344 0.784041 5.33432C0.469333 6.04467 0.245222 6.78581 0.116478 7.55062C0.0592586 7.88212 0.0306488 8.21598 0.0163439 8.54985C0.00203901 8.85057 0.00203901 9.14891 0.0163439 9.44963C0.0282647 9.72904 0.0521062 10.0108 0.0902526 10.2878C0.142704 10.6738 0.233302 11.0527 0.338204 11.4268C0.457412 11.8577 0.602845 12.2816 0.791193 12.6888C0.979541 13.0937 1.19888 13.4821 1.4373 13.8609C1.57796 14.0835 1.72816 14.2966 1.89029 14.5097C5.44744 9.91609 8.99982 5.32248 12.5522 0.733602C12.5451 0.717027 12.5308 0.71466 12.5188 0.709924ZM3.05375 11.1379C2.81057 11.4505 2.56739 11.7654 2.31943 12.0732C2.17162 12.2579 1.91651 12.3171 1.70909 12.2082C1.45637 12.0732 1.3014 11.7441 1.5279 11.4741C1.61134 11.3747 1.68525 11.2681 1.76393 11.1639C1.92366 10.9532 2.07863 10.7377 2.24076 10.5294C2.37427 10.3565 2.55308 10.2831 2.77004 10.3328C2.987 10.3826 3.11097 10.5246 3.15627 10.7401C3.15865 10.7472 3.15865 10.7567 3.16104 10.7638C3.16104 10.7851 3.16104 10.8064 3.16104 10.8277C3.16342 10.9414 3.12528 11.0456 3.05375 11.1379ZM4.8824 8.78427C4.68213 9.03999 4.48186 9.29809 4.28159 9.55382C4.24583 9.60117 4.21006 9.64853 4.17192 9.69352C4.06463 9.82849 3.91681 9.89952 3.6784 9.89715C3.5282 9.89242 3.38753 9.77166 3.29932 9.5917C3.21349 9.42122 3.24687 9.2602 3.36369 9.10866C3.60449 8.79611 3.83814 8.47882 4.07655 8.16389C4.20291 7.99814 4.37457 7.92711 4.57722 7.96263C4.78226 7.99814 4.91816 8.1189 4.97538 8.32254C5.02544 8.49302 4.98968 8.64693 4.8824 8.78427ZM6.69673 6.43063C6.4607 6.73372 6.22467 7.03443 5.98864 7.33515C5.85275 7.508 5.66917 7.55772 5.46413 7.508C5.27101 7.46064 5.14704 7.32804 5.09697 7.13625C5.05882 6.98471 5.09935 6.84264 5.18995 6.72424C5.4379 6.40222 5.69301 6.08729 5.95049 5.77C6.07209 5.62083 6.23659 5.5711 6.42017 5.61136C6.61806 5.65398 6.74203 5.78421 6.79687 5.98074C6.80879 6.02099 6.81117 6.06125 6.80879 6.11571C6.81594 6.227 6.77303 6.33355 6.69673 6.43063ZM8.59452 3.9515C8.52538 4.09831 8.41332 4.21433 8.31796 4.33983C8.15107 4.55767 7.98179 4.77551 7.81013 4.98862C7.68139 5.14963 7.50496 5.21119 7.30708 5.17094C7.09727 5.12832 6.96138 4.99572 6.91369 4.78498C6.90654 4.75183 6.90654 4.71395 6.90177 4.67843C6.90416 4.5553 6.95422 4.45348 7.02575 4.35877C7.25701 4.05332 7.49066 3.75023 7.72669 3.44715C7.88166 3.24825 8.13199 3.17722 8.34657 3.2814C8.6279 3.42347 8.71134 3.70288 8.59452 3.9515ZM10.3683 1.70679C10.1299 2.02408 9.88673 2.33663 9.64355 2.65155C9.5148 2.8173 9.28115 2.8836 9.08089 2.81967C8.88062 2.75574 8.74234 2.57105 8.73518 2.35557C8.7328 2.22534 8.78287 2.10695 8.85678 2.00513C9.09042 1.69495 9.32884 1.38713 9.56725 1.07931C9.665 0.953812 9.79852 0.885144 9.97494 0.878041C10.1704 0.894616 10.3254 0.998801 10.4232 1.17639C10.5281 1.36108 10.4899 1.54577 10.3683 1.70679Z"
                      fill="#8B191B"
                    ></path>
                    {/* paths here */}
                  </svg>
                  <div className="mt-0.5 text-base md:text-[18px] font-semibold leading-3 tracking-wide text-center text-text_color_primary1">
                    Cricket
                  </div>
                </>
              )}
              {effectiveEventType === 2 && (
                <>
                  {/* Tennis SVG */}
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 19 18"
                    fill="var(--icon-color-ternary)"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    {/* paths here */}
                    <path
                      d="M9.5403 19.3516C9.28848 19.3516 9.03913 19.3516 8.78731 19.3516C8.74781 19.3516 8.73546 19.3442 8.73793 19.3021C8.78237 18.8565 8.7725 18.4135 8.75275 17.9679C8.73546 17.5595 8.69596 17.1535 8.6219 16.7526C8.49599 16.0743 8.30836 15.4109 8.06395 14.7624C7.68128 13.7476 7.15542 12.8119 6.4839 11.9579C6.13086 11.5074 5.74326 11.0891 5.3285 10.698C4.65698 10.0668 3.91387 9.53709 3.09916 9.10639C2.31902 8.69549 1.50924 8.3638 0.652565 8.15835C0.548875 8.1336 0.445185 8.11132 0.341495 8.08904C0.306931 8.08162 0.294587 8.07419 0.301994 8.02964C0.363714 7.74498 0.418028 7.45785 0.49703 7.17566C0.679722 6.51724 0.93401 5.88604 1.26977 5.28949C1.51418 4.85137 1.78081 4.42809 2.09188 4.03452C2.43505 3.59887 2.81031 3.19788 3.23001 2.83648C3.64724 2.47509 4.09162 2.15578 4.56811 1.87607C5.41244 1.38349 6.30862 1.02953 7.26405 0.829027C7.68128 0.742392 8.10592 0.687936 8.53302 0.660707C9.02678 0.631004 9.52055 0.650806 10.0143 0.660707C10.0513 0.660707 10.0587 0.675559 10.0563 0.707738C10.0513 0.801799 10.0513 0.898335 10.0464 0.992396C10.0316 1.30428 10.0365 1.61617 10.0464 1.92558C10.0587 2.28697 10.0958 2.64589 10.1452 3.00233C10.2143 3.49244 10.318 3.97512 10.4562 4.45037C10.6636 5.16821 10.9549 5.84891 11.3055 6.50734C11.6462 7.14844 12.0437 7.74993 12.5053 8.30935C13.004 8.91331 13.5669 9.4554 14.1866 9.93313C14.9124 10.495 15.6951 10.9629 16.5295 11.344C17.122 11.6139 17.7392 11.8144 18.3688 11.9752C18.5021 12.0099 18.4996 12.0099 18.4749 12.1411C18.3169 12.9802 18.038 13.7797 17.6479 14.5372C17.3343 15.1411 16.9517 15.6981 16.5122 16.2179C15.9074 16.9308 15.2087 17.5347 14.4162 18.0248C13.5669 18.5521 12.6584 18.9358 11.6832 19.1536C11.2586 19.2476 10.8265 19.3095 10.392 19.3417C10.1081 19.3615 9.82421 19.3665 9.5403 19.3665C9.5403 19.3615 9.5403 19.3566 9.5403 19.3516Z"
                      fill="#7FBA42"
                    ></path>
                    <path
                      d="M0.00561523 10.3862C0.338905 10.4729 0.659851 10.5694 0.975859 10.6882C1.85969 11.0174 2.65712 11.4952 3.38048 12.0967C3.95819 12.5769 4.45442 13.1338 4.8914 13.7452C5.42219 14.4903 5.8172 15.3046 6.08137 16.1809C6.22456 16.6561 6.32331 17.1388 6.38009 17.6289C6.41713 17.9458 6.43194 18.2626 6.43935 18.5794C6.44181 18.6686 6.44181 18.7577 6.41713 18.8443C6.39244 18.9285 6.37269 18.9359 6.29122 18.9062C5.56785 18.6413 4.88893 18.2898 4.25198 17.8567C3.86684 17.5943 3.50393 17.3047 3.15829 16.9928C2.71884 16.5943 2.32136 16.1586 1.96339 15.6858C1.64244 15.2626 1.36099 14.817 1.11411 14.3467C0.763541 13.6809 0.489503 12.9853 0.299404 12.2576C0.178432 11.7848 0.0895549 11.3046 0.0401786 10.8194C0.0253657 10.6759 0.0179593 10.5323 0.00561523 10.3862Z"
                      fill="#7FBA42"
                    ></path>
                    <path
                      d="M19.0056 9.63093C18.3218 9.45518 17.6725 9.21013 17.0553 8.87596C16.5097 8.5814 16.006 8.22744 15.5369 7.82397C14.8481 7.23237 14.2704 6.54672 13.8014 5.77196C13.3718 5.05907 13.0484 4.29916 12.8385 3.49222C12.7151 3.01944 12.6336 2.53923 12.599 2.0516C12.5793 1.78922 12.5694 1.52437 12.5768 1.25951C12.5768 1.24218 12.5793 1.22238 12.5818 1.20505C12.604 1.08624 12.6262 1.07386 12.7373 1.11594C13.3027 1.32634 13.8433 1.58872 14.3593 1.90308C14.8728 2.21745 15.3567 2.57389 15.806 2.97241C16.127 3.25707 16.4282 3.56648 16.7072 3.89569C17.4429 4.76699 18.0082 5.73978 18.423 6.80167C18.6501 7.38337 18.8032 7.98486 18.8995 8.60121C18.9513 8.93289 18.9809 9.26706 19.0056 9.60122C19.0056 9.61112 19.0056 9.62102 19.0056 9.63093Z"
                      fill="#7FBA42"
                    ></path>
                  </svg>
                  <div className="mt-0.5 text-base md:text-[18px] font-semibold leading-3 tracking-wide text-center text-text_color_primary1">
                    Tennis
                  </div>
                </>
              )}
              {effectiveEventType === 1 && (
                <>
                  {/* Football SVG */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    x="0"
                    y="0"
                    viewBox="0 0 510.731 510.731"
                    class=""
                    fill="currentColor"
                  >
                    <g>
                      <path
                        d="M489.324 293.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM489.324 313.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM469.324 273.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM479.701 283.552a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM469.324 293.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM479.701 303.552a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM469.324 313.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM479.701 323.552a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM469.324 333.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM479.701 343.552a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM469.324 353.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM469.324 373.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM462.803 260.45c0-1.45-1-2.659-2.345-2.998-.441 2.02-.904 4.032-1.392 6.035a3.103 3.103 0 0 0 3.737-3.037zM459.701 283.552a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM452.427 290.827a3.09 3.09 0 0 0-.867-2.144 256.678 256.678 0 0 1-1.905 5.212 3.09 3.09 0 0 0 2.772-3.068zM459.701 303.552a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM449.324 313.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM459.701 323.552a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM449.324 333.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM459.701 343.552a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM449.324 353.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM459.701 363.552a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM449.324 373.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM459.701 383.552a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM449.324 393.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM439.701 317.348c-.09 0-.175.019-.264.027a263.487 263.487 0 0 1-2.378 4.683 3.09 3.09 0 0 0 2.641 1.495 3.102 3.102 0 0 0 .001-6.205zM430.695 333.597a3.092 3.092 0 0 0 1.732-2.77c0-.071-.016-.138-.021-.209-.566.996-1.133 1.991-1.711 2.979zM439.701 337.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM429.324 347.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM439.701 357.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM429.324 367.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM439.701 377.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM429.324 387.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM439.701 397.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM429.324 407.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM419.701 357.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM409.324 367.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM419.701 377.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM409.324 387.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM419.701 397.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM409.324 407.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM399.701 377.348c-.552 0-1.063.156-1.512.409-.446.489-.887.982-1.337 1.468a3.102 3.102 0 1 0 2.849-1.877zM389.324 387.724c-.279 0-.545.049-.802.118-.711.702-1.434 1.39-2.152 2.084a3.051 3.051 0 0 0-.148.9 3.102 3.102 0 1 0 3.102-3.102zM399.701 397.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM389.324 407.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM379.701 397.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM369.324 407.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM332.427 430.827c0-.238-.033-.468-.083-.691a267.15 267.15 0 0 1-5.234 2.858 3.087 3.087 0 0 0 2.216.935 3.102 3.102 0 0 0 3.101-3.102zM339.701 443.552a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM329.324 453.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM329.324 473.929a3.102 3.102 0 1 0 0-6.204 3.102 3.102 0 0 0 0 6.204zM316.599 440.45a3.102 3.102 0 1 0 6.203 0 3.102 3.102 0 0 0-6.203 0zM309.324 447.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM319.701 457.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM309.324 467.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM319.701 477.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM309.324 487.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM286.261 450.439c-.016.128-.039.255-.039.388a3.102 3.102 0 1 0 5.302-2.186 267.01 267.01 0 0 1-5.263 1.798zM299.701 457.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM289.324 467.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM299.701 477.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM289.324 487.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM279.701 457.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM269.324 467.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM279.701 477.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM269.324 487.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM260.493 457.463c-.916.2-1.83.409-2.75.6a3.08 3.08 0 0 0-1.144 2.387 3.102 3.102 0 1 0 6.204 0 3.093 3.093 0 0 0-2.31-2.987zM249.324 467.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM259.701 477.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM249.324 487.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM239.701 463.552a3.092 3.092 0 0 0 3.077-2.85 260.47 260.47 0 0 1-5.98.812 3.094 3.094 0 0 0 2.903 2.038zM229.324 467.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM239.701 477.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM229.324 487.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM221.502 462.968c-1.094.071-2.191.131-3.289.189.444.245.946.396 1.488.396a3.092 3.092 0 0 0 1.801-.585zM209.324 467.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM219.701 477.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM209.324 487.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM200.15 463.507c-.36-.005-.72-.012-1.081-.019.204.042.415.065.631.065.155-.001.302-.024.45-.046zM189.324 467.724a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM199.701 477.348a3.102 3.102 0 1 0 0 6.204 3.102 3.102 0 0 0 0-6.204zM179.701 463.552c.872 0 1.658-.363 2.222-.942-1.607-.135-3.21-.288-4.808-.451a3.092 3.092 0 0 0 2.586 1.393z"
                        fill="currentColor"
                        opacity="1"
                      ></path>
                      <path
                        d="M510.662 249.631a259.482 259.482 0 0 0-1.508-22.741c-6.333-57.441-31.761-110.644-73.217-152.1-35.394-35.394-79.353-59.101-127.199-69.223-35.063-7.422-71.685-7.422-106.748 0-47.846 10.122-91.805 33.829-127.199 69.223-42.697 42.696-68.395 97.853-73.736 157.267a256.432 256.432 0 0 0-.806 34.486C2.936 329.317 28.212 388.019 72.18 433.26c4.297 4.451 8.786 8.715 13.391 12.838 46.811 41.779 106.542 64.633 169.794 64.633 63.239 0 122.959-22.846 169.766-64.609 4.596-4.115 9.08-8.369 13.369-12.812 46.051-47.358 71.608-109.478 72.204-175.581.055-2.699.018-5.402-.042-8.098zM259.315 101.934l98.708-71.715c41.903 19.183 77.558 49.726 103.004 87.669l-36.909 96.374-63.89 20.759-100.914-73.318v-59.769zM152.704 30.218l98.708 71.715v59.768L150.498 235.02l-67.21-21.838-35.428-92.504c25.555-39.236 61.919-70.81 104.844-90.46zM65.566 413.97C34.34 376.665 13.888 330.058 9.03 278.968l71.998-58.211 66.69 21.669 38.675 119.029-38.825 53.437zm286.657 3.774-3.126 10.003a3.092 3.092 0 0 0-2.874 3.079c0 .974.458 1.833 1.161 2.402l-7.543 24.133c-.047-.002-.092-.014-.139-.014a3.102 3.102 0 0 0-3.102 3.102c0 1.107.585 2.072 1.457 2.621l-7.758 24.824a3.079 3.079 0 0 0-.973-.171 3.102 3.102 0 0 0-3.102 3.102c0 .558.159 1.075.417 1.527a245.143 245.143 0 0 1-24.616 6.058 3.084 3.084 0 0 0-2.322-1.064 3.095 3.095 0 0 0-2.891 2c-4.673.792-9.39 1.451-14.147 1.975a3.08 3.08 0 0 0 .14-.874 3.102 3.102 0 0 0-6.204 0c0 .52.14 1.002.366 1.433-5.02.436-10.082.723-15.182.854a3.082 3.082 0 0 0 1.021-2.286 3.102 3.102 0 0 0-6.204 0 3.08 3.08 0 0 0 1.106 2.356c-.78.007-1.559.022-2.341.022-4.47 0-8.911-.127-13.323-.363a3.072 3.072 0 0 0 .762-2.016 3.102 3.102 0 0 0-6.204 0c0 .631.191 1.216.514 1.705a247.42 247.42 0 0 1-14.333-1.469c.006-.079.024-.155.024-.236a3.102 3.102 0 0 0-6.133-.652 245.52 245.52 0 0 1-27.194-5.885 3.095 3.095 0 0 0-.151-6.189 3.098 3.098 0 0 0-1.77 5.645 247.416 247.416 0 0 1-6.079-1.809l-2.536-8.113c.245.062.497.105.761.105a3.102 3.102 0 0 0 0-6.204c-.934 0-1.762.422-2.331 1.075l-18.964-60.678a3.938 3.938 0 0 0-1.606-2.113l35.858-49.355h125.411l35.827 49.312a3.94 3.94 0 0 0-1.677 2.158zm10.935-2.853-38.824-53.436 38.675-119.029 63.41-20.603 59.865 48.402a3.102 3.102 0 0 0 4.267 3.45l6.473 5.234a3.07 3.07 0 0 0-.425 1.541 3.102 3.102 0 0 0 3.102 3.102c.572 0 1.1-.165 1.56-.435a247.283 247.283 0 0 1-2.027 14.278 3.094 3.094 0 0 0-2.635 3.055c0 1.155.639 2.152 1.576 2.685a245.435 245.435 0 0 1-6.499 25.688 3.08 3.08 0 0 0-2.35-1.098 3.102 3.102 0 0 0 0 6.204c.252 0 .494-.038.728-.095a245.953 245.953 0 0 1-9.329 23.7 3.072 3.072 0 0 0-1.023-.186 3.102 3.102 0 0 0-3.102 3.102c0 1.125.605 2.101 1.501 2.645a247.965 247.965 0 0 1-27.98 44.745 3.074 3.074 0 0 0-.796-.116 3.102 3.102 0 0 0-3.102 3.102c0 .514.137.991.358 1.417-.472.575-.94 1.154-1.418 1.725z"
                        fill="currentColor"
                        opacity="1"
                      ></path>
                    </g>
                  </svg>
                  <div className="mt-0.5 text-base md:text-[18px] font-semibold leading-3 tracking-wide text-center text-text_color_primary1">
                    Football
                  </div>
                </>
              )}
            </div>

            {/* Right: 1 X 2 */}
            <div className="col-span-6 lg:col-span-6 grid grid-cols-12 h-full py-2.5">
              {["1", "X", "2"].map((label) => (
                <span
                  key={label}
                  className="col-span-4 flex items-center justify-center text-xs font-semibold mt-0.5 text-text_color_primary1 tracking-[0.3px] text-center"
                >
                  {label}
                </span>
              ))}
            </div>
          </div>
        )}

        {isDashboardInplayView ? (
          <>
            {!isMobile &&
              dashboardInplayGroups.some(
                (group) => group.events.length > 0,
              ) && (
                <div className="reference-inplay-title">
                  <img
                    src={`${process.env.PUBLIC_URL}/Images/inplayico.png`}
                    alt=""
                    className="reference-inplay-title-icon"
                  />
                  {effectiveTableTitle}
                </div>
              )}

            {dashboardInplayGroups.map(
              ({ sportType, sport, events: sportEvents }) => {
                if (sportEvents.length === 0) return null;

                return (
                  <section
                    key={sportType}
                    className="dashboard-inplay-sport-section"
                  >
                    {!isMobile && renderDesktopSportHeader(sport)}

                    <div className="matches-scroll-container">
                      {sportEvents.map((event, index) => (
                        <TableRow
                          key={String(event.event_id)}
                          i={index}
                          row={event}
                          isMobile={isMobile}
                          username={userInfo?._id}
                        />
                      ))}
                    </div>
                  </section>
                );
              },
            )}
          </>
        ) : (
          <>
            {events?.length > 0 && !isMobile && (
              <>
                <div className="reference-inplay-title">
                  <img
                    src={`${process.env.PUBLIC_URL}/Images/inplayico.png`}
                    alt=""
                    className="reference-inplay-title-icon"
                  />
                  {effectiveTableTitle}
                </div>

                {renderDesktopSportHeader(activeSport)}
              </>
            )}

            <div className="matches-scroll-container">
              {events?.map((event, index) => (
                <TableRow
                  key={String(event.event_id)}
                  i={index}
                  row={event}
                  isMobile={isMobile}
                  username={userInfo?._id}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default UpcomingEvents;
